import { swNumberFilter } from "app/filters/ngFilters";

import { PLUS_SUFFIX } from "../const";

export const mappingValueToLabel = (value: string): string => {
    const splitValue = value.split("_");
    return splitValue[2] === PLUS_SUFFIX
        ? `>${swNumberFilter()(splitValue[1])}`
        : `${swNumberFilter()(splitValue[1])}-${swNumberFilter()(splitValue[2])}`;
};
